import React, { useState } from 'react';
import styled from '@emotion/styled';
import Modal from 'react-modal';
import { useLocalization } from 'gatsby-theme-i18n';
import IconPackage from 'xiv-fanfes-2021';
import { GatsbyImage } from "gatsby-plugin-image";
import Popup from './Popup';

import * as breakpoint from '../../styles/breakpoints.module.scss';

const Sponsor = ({ data, type }) => {
  const [ modalOpened, setModalOpened ] = useState(false);
  const { localeKey } = useLocalization();
  Modal.setAppElement('#___gatsby');

  const logo = data.localeLogo[localeKey] ? data.localeLogo[localeKey].childImageSharp.gatsbyImageData : data.localeLogo['default'].childImageSharp.gatsbyImageData ;

  if(data.data[localeKey] === "")
  {
    return (<></>);
  }

  if(type === "plainList")
  {
    return(
      <PlainListBrandLogo>
        <GatsbyImage image={logo} alt={data.brand[localeKey]} title={data.brand[localeKey]}/>
      </PlainListBrandLogo>);
  }
  else
  {
  return (
    <SponsorWrapper>
      <SponsorCard>
        {(data.data[localeKey] === "logo" && data.url[localeKey])  &&
          <ButtonOverlay href={data.url[localeKey]} target="_blank" rel="nofollow noreferrer" title={data.brand[localeKey]}>
            <IconWrapper>
              <IconPackage.Icon type={'ExternalLink'} />
            </IconWrapper>
          </ButtonOverlay>
        }
        
        {data.data[localeKey] === "modal" &&
          <>
            <ButtonOverlay href={'#'} onClick={(e) => {
              e.preventDefault();
              setModalOpened(true);
            }} title={data.brand[localeKey]}>
              <IconWrapper>
                <IconPackage.Icon type={'Plus'} />
              </IconWrapper>
            </ButtonOverlay>
            <Modal
              style={{
                overlay: {
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: 'transparent',
                  zIndex: 999,
                  padding: 0
                },
                content: {
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: 'transparent',
                  zIndex: 999,
                  border: 0,
                  borderRadius: 0,
                  padding: 0
                }
              }}
              isOpen={modalOpened}
            >
              <Popup 
                logo={logo} 
                brand={data.brand[localeKey]} 
                desc={data.description[localeKey]} 
                url={data.url[localeKey]} 
                campaignUrl={data.campaign_url[localeKey]} setModal={setModalOpened} isOpen={modalOpened}/>
            </Modal>
          </>
        }
      {logo && 
        <BrandLogo>
          <GatsbyImage image={logo} alt={data.brand[localeKey]} title={data.brand[localeKey]}/>
        </BrandLogo>}
      
      <BrandText>{data.brand[localeKey]}</BrandText>
      </SponsorCard>
    </SponsorWrapper>);
  }
}
 
export default Sponsor;

const SponsorWrapper = styled.div`
  width:33.33%;
  padding:24px;

  @media only screen and (max-width: ${breakpoint.smMax}){
    width:50%;
    padding: 16px;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    width:100%;
    padding: 0 0 24px;
  }
`

const SponsorCard = styled.div`
  background: #FCFCFF;
  padding:32px;
  min-height:100%;

  box-shadow: 0px 2px 2px -2px rgba(0, 0, 0, 0.05), 0px 6px 6px -6px rgba(0, 0, 0, 0.03), 0px 16px 14px -14px rgba(0, 0, 0, 0.03);
  border-radius: 6px;
  transition: all .3s;

  display:flex;
  justify-content: center;
  flex-direction: column;
  position: relative;

  &:hover{
    box-shadow: 0px 6px 4px -4px rgba(0, 0, 0, 0.1), 0px 12px 8px -8px rgba(0, 0, 0, 0.05), 0px 24px 16px -16px rgba(0, 0, 0, 0.05);
  }

  &:active{
    box-shadow: none;
  }

`
const PlainListBrandLogo = styled.div`
margin:0 12px 24px;
width:208px;

@media only screen and (max-width: ${breakpoint.smMax}){
  width:128px;
  margin:0 16px 16px;
}

@media only screen and (max-width: ${breakpoint.xsMax}){
  width:80px;
  margin:0 8px 16px;
}
`

const BrandLogo = styled.div`
  margin-bottom:24px;
`


const BrandText = styled.div`
  font-weight: 900;
  font-size: 16px;
  line-height: 24px;

  text-align: center;
  letter-spacing: 0.03em;
  font-feature-settings: 'palt' on;

  color: #787880;
`

const ButtonOverlay = styled.a`
  position:absolute;
  top:0;
  left:0;
  right:0;
  bottom:0;
  z-index: 10;
  cursor: pointer;

  > div{
    opacity:0;
  }


  &:hover > div{
    opacity:1;
  }

  &:active > div{
    > svg{
      color:#6E6E70;
    }
  }

`

const IconWrapper = styled.div`
  position:absolute;
  display:block;
  width:32px;
  height:32px;
  top:16px;
  right:16px;
  transition: all .3s;

  > svg{
    width:100%;
    height:100%;
    color:#CACACD;
  }  
`

